import PropTypes from 'prop-types';
import React, { Component } from 'react';
import './index.scss';

class PresenceBadge extends Component {
  static propTypes = {
    presence: PropTypes.oneOf([
      'Online',
      'Offline',
      'Unavailable',
      undefined,
      null,
    ]),
    children: PropTypes.any,
  };

  render() {
    if (!this.props.presence) {
      return this.props.children || null;
    }
    return (
      <div
        className={`PresenceBadge PresenceBadge-${this.props.presence.toLowerCase()}`}
      >
        {this.props.children}
      </div>
    );
  }
}

export default PresenceBadge;
